import { Extension } from '@tiptap/core';
import { TableCell } from '../cell/index';
import { TableHeader } from '../header/index';
import { TableRow } from '../row/index';
import { Table } from '../table/index';
/**
 * The table kit is a collection of table editor extensions.
 *
 * It’s a good starting point for building your own table in Tiptap.
 */
export const TableKit = Extension.create({
    name: 'tableKit',
    addExtensions() {
        const extensions = [];
        if (this.options.table !== false) {
            extensions.push(Table.configure(this.options.table));
        }
        if (this.options.tableCell !== false) {
            extensions.push(TableCell.configure(this.options.tableCell));
        }
        if (this.options.tableHeader !== false) {
            extensions.push(TableHeader.configure(this.options.tableHeader));
        }
        if (this.options.tableRow !== false) {
            extensions.push(TableRow.configure(this.options.tableRow));
        }
        return extensions;
    },
});
